// src/components/common/materials/OutSummary.jsx
import React from "react";

export default function OutSummary({ form }) {
  const { title, issue_date, to_site, warehouse, reason, note, items = [], subtotal, vat_total, total } = form || {};

  return (
    <div className="space-y-2 text-sm">
      <div className="grid grid-cols-2 gap-2">
        <div className="text-gray-500">제목</div>
        <div className="font-medium">{title || "-"}</div>

        <div className="text-gray-500">출고일</div>
        <div>{issue_date || "-"}</div>

        <div className="text-gray-500">출고처</div>
        <div>{to_site || "-"}</div>

        <div className="text-gray-500">창고</div>
        <div>{warehouse || "-"}</div>
      </div>

      {items.length > 0 && (
        <div className="mt-3">
          <div className="text-xs text-gray-500 mb-1">품목 ({items.length}건)</div>
          <div className="space-y-1">
            {items.slice(0, 3).map((item, i) => (
              <div key={i} className="flex justify-between text-xs bg-gray-50 px-2 py-1 rounded">
                <span>{item.name || item.code}</span>
                <span>{Number(item.qty).toLocaleString()} {item.unit}</span>
              </div>
            ))}
            {items.length > 3 && (
              <div className="text-xs text-gray-400">외 {items.length - 3}건...</div>
            )}
          </div>
        </div>
      )}

      <div className="border-t pt-2 mt-2 flex justify-between font-medium">
        <span>합계</span>
        <span>{Number(total || 0).toLocaleString()}원</span>
      </div>
    </div>
  );
}
